var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-date"},[_c('input',{ref:"input",attrs:{"type":"text"},on:{"input":_vm.inputHandler,"keydown":_vm.keydownHandler,"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.clickHandler.apply(null, arguments)},"blur":_vm.blurHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }